module.exports = __webpack_public_path__ + "img/lait.292441cf.svg";